var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGopas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54px",
    height: "11px",
    viewBox: "0 0 54 11",
    style: {
      enableBackground: "new 0 0 54 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#03326C;}\r\n\t.st1{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,5L4.7,5c1.9-1.9,3.7-2.6,4.4-2c0.2,0.2,0.2,0.4,0.2,0.8c0,0.2,0.2,0.2,0.2,0c0.1-0.6-0.1-1-0.6-1.5 c-1.9-1.9-5.1-2-7,0c-1.9,1.9-1.9,5.1,0,7c0.5,0.5,0.9,0.6,1.5,0.6c0.2,0,0.2-0.2,0-0.2c-0.3,0-0.6-0.1-0.8-0.2 C2.1,8.7,2.9,6.9,4.7,5L4.7,5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,6.5L8.2,6.5c-1.9,1.9-3.7,2.6-4.4,2C3.6,8.3,3.6,8,3.6,7.7c0-0.2-0.2-0.2-0.2,0C3.3,8.3,3.5,8.7,4,9.2 c1.9,1.9,5.1,2,7,0c1.9-1.9,1.9-5.1,0-7c-0.5-0.5-0.9-0.6-1.5-0.5c-0.2,0-0.2,0.2,0,0.2c0.3,0,0.6,0.1,0.8,0.2 C10.8,2.7,10.1,4.6,8.2,6.5L8.2,6.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,5.6c0,2.9-1.8,4.6-4.1,4.6c-2.4,0-4-1.9-4-4.4c0-2.7,1.7-4.5,4.1-4.5C29.3,1.2,30.8,3.1,30.8,5.6  M24.3,5.7c0,1.8,0.9,3.2,2.4,3.2c1.5,0,2.4-1.4,2.4-3.2c0-1.6-0.8-3.2-2.4-3.2C25.2,2.5,24.3,3.9,24.3,5.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,1.5c0.6-0.1,1.4-0.2,2.4-0.2c1.2,0,2,0.2,2.5,0.7c0.5,0.4,0.8,1.1,0.8,1.9c0,0.8-0.3,1.5-0.7,1.9 c-0.6,0.6-1.6,0.9-2.7,0.9c-0.3,0-0.6,0-0.8-0.1V10H32 M33.5,5.5c0.2,0.1,0.4,0.1,0.8,0.1c1.2,0,1.9-0.6,1.9-1.6 c0-1-0.7-1.5-1.8-1.5c-0.4,0-0.7,0-0.9,0.1V5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,7.6L39.2,10h-1.6l2.8-8.6h2l2.8,8.6h-1.7l-0.8-2.4 M42.4,6.4l-0.7-2.1c-0.2-0.5-0.3-1.1-0.4-1.6h0 c-0.1,0.5-0.3,1.1-0.4,1.6l-0.7,2.1H42.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.1,8.3c0.5,0.3,1.3,0.6,2.1,0.6c1,0,1.6-0.5,1.6-1.2c0-0.7-0.4-1-1.5-1.4c-1.4-0.5-2.3-1.3-2.3-2.5 c0-1.4,1.2-2.5,3.1-2.5c0.9,0,1.6,0.2,2.1,0.4l-0.4,1.3c-0.3-0.2-0.9-0.4-1.7-0.4c-1,0-1.4,0.5-1.4,1c0,0.7,0.5,1,1.7,1.4 c1.5,0.6,2.2,1.3,2.2,2.6c0,1.4-1.1,2.6-3.3,2.6c-0.9,0-1.9-0.3-2.3-0.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,8.7c-0.2,0.1-0.6,0.2-1.2,0.2c-1.8,0-3-1.2-3-3.1c0-2,1.3-3.1,3.1-3.1c0.9,0,1.5,0.2,2,0.4l0.3-1.3 c-0.4-0.2-1.2-0.4-2.3-0.4c-2.9,0-4.8,1.7-4.8,4.5c0,1.3,0.4,2.4,1.2,3.2c0.8,0.8,1.9,1.2,3.4,1.2c1.1,0,2.2-0.3,2.8-0.5V5.3h-1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,1.6c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7C52.2,1.9,52.5,1.6,52.9,1.6  M52.9,2.9c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.2-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6C52.3,2.6,52.5,2.9,52.9,2.9z M52.6,1.9h0.3 c0.2,0,0.3,0.1,0.3,0.2c0,0.1-0.1,0.2-0.2,0.2l0.2,0.4h-0.1l-0.2-0.4h-0.1v0.4h-0.1V1.9z M52.7,2.2h0.2c0.1,0,0.2,0,0.2-0.1 C53,2,53,2,52.9,2h-0.2V2.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.8,
    className: "st1",
    width: 53,
    height: 9.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGopas);
export default __webpack_public_path__ + "static/media/gopas.609772686a12b0dec099ad62ca940cb8.svg";
export { ForwardRef as ReactComponent };